export default {
  machinesInServicePercentage: ({ machinesInServicePercentage }) =>
    machinesInServicePercentage
};
